import {Component, OnInit} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-trams-invoice-component',
    templateUrl: './trams-invoice.component.html',
    standalone: false
})
@AutoUnsubscribe()
export class TramsInvoiceComponent implements OnInit {
  invoiceData: any;

  constructor(
    private route: ActivatedRoute,
  ) {
  }

  public ngOnInit(): void{
    this.route.paramMap.subscribe(params => {
      this.invoiceData = {
        invoiceId: params.get('invoiceId')
      }
    });
  }
}
